import { FlexRow } from '@layout/BuildingBlocks'
import React from 'react'
import { useTheme } from 'styled-components'
import { getThemeValue } from 'theming'

export const SlotLeft = ({ children, ...props }) => {
  const theme = useTheme()
  const iconSpaceLeft = getThemeValue(theme, 'badge.icon.space.x')
  const iconSpaceRight = getThemeValue(theme, 'badge.icon.space.x')

  return (
    <FlexRow {...props} ml={iconSpaceLeft} mr={iconSpaceRight}>
      {children}
    </FlexRow>
  )
}
